import * as React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import NewBusiness from "./NewBusiness";
import NewContact from "./NewContact";
import { Customer, CustomerTypeWithBoth } from "src/model/Customer";

export interface Props {
    onCreate?: (customer: Customer) => void;
    noRedirect?: boolean;
    include?: CustomerTypeWithBoth | undefined;
}

export interface State {
    isShown: boolean;
    activeTab: string;
}

export default class NewCustomerDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isShown: false,
            activeTab: "contact"
        };
    }

    toggle = (): void => {
        this.setState(prevState => ({
            isShown: !prevState.isShown
        }));
    };

    toggleTab = (tab: string): any => {
        if (this.state.activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    };

    render() {
        const include = this.props.include ? this.props.include : "BOTH";
        return (
            <div>
                <Modal isOpen={this.state.isShown} toggle={this.toggle} className="modal-md" centered={true}>
                    <ModalHeader toggle={this.toggle}>New Customer</ModalHeader>
                    <ModalBody>
                        <div className="container-fluid">
                            <ul className="nav nav-tabs">
                                {(include === "CONTACT" || include === "BOTH") && (
                                    <li className="nav-item">
                                        <a
                                            className={"nav-link " + (this.state.activeTab === "contact" ? "active" : "")}
                                            onClick={() => this.toggleTab("contact")}
                                        >
                                            Contact
                                        </a>
                                    </li>
                                )}
                                {(include === "BUSINESS" || include === "BOTH") && (
                                    <li className="nav-item">
                                        <a
                                            className={"nav-link " + (this.state.activeTab === "business" ? "active" : "")}
                                            onClick={() => this.toggleTab("business")}
                                        >
                                            Business
                                        </a>
                                    </li>
                                )}
                            </ul>
                            {this.state.activeTab === "contact" && (
                                <NewContact toggleFunction={this.toggle} onCreate={this.props.onCreate} noRedirect={this.props.noRedirect} />
                            )}
                            {this.state.activeTab === "business" && (
                                <NewBusiness toggleFunction={this.toggle} onCreate={this.props.onCreate} noRedirect={this.props.noRedirect} />
                            )}
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/customer/NewCustomerDialog.tsx